import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=aff93036"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports